import Auth from "../libs/API/Auth";
import Users from "../libs/API/Users";
import Alert from "./Alert";
class NotificationCompleteProfileClass{
    constructor(){
        this.main = document.getElementById('notification-complete-profile');
        this._notificationText = null;
    }

    init(){
        this._notificationText = this.main.querySelector('.notification-text');

        Auth.addEventListener('sessionReady', async ()=>{
            if (Auth.isUserLogged && !Auth.isInternalLogged && !Auth.user.verified_profile) {
                this.show();
            }
        })
    }

    show(){
        if (Auth.user.completed_profile) {
            this._notificationText.innerHTML = `Your profile is currently awaiting validation. <a class="learn-more color-orange-600" href="#">Learn more</a>`;
            this.main.querySelector('.learn-more').addEventListener('click', (e) => {
                e.preventDefault();
                Alert.show('campaigns', 'Your profile is now completed', "We'll review your profile and notify you once your account has been successfully validated, so you can start using bSuite.", 'Got it');
            });
        } else {
          this._notificationText.innerHTML = `Please
              <a class="color-orange-600" href="/bsuite/customer/user/profile">
                complete your profile
              </a>
              to validate your account so you can start operating in bSuite.`;
        }
        this.main.classList.add('active');
    }
    
    hide(){
        this.main.classList.remove('active');
    }
}

const NotificationCompleteProfile = new NotificationCompleteProfileClass();
Object.seal(NotificationCompleteProfile);

export default NotificationCompleteProfile;